// extracted by mini-css-extract-plugin
export default {"diffComponentTitle":"DiffComponentTitle_diffComponentTitle__tqnTB"};